import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState, useCallback } from 'react';
export function useActiveState() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var handleMouseDown = useCallback(function () {
    setActive(true);
  }, []);
  var handleMouseUp = useCallback(function () {
    setActive(false);
  }, []);
  return {
    isActive: active,
    bind: {
      onMouseDown: handleMouseDown,
      onMouseUp: handleMouseUp,
      onMouseLeave: handleMouseUp
    }
  };
}